(function () {
  function createSparkle(x, y) {
    const sparkle = document.createElement('div');
    sparkle.className = 'atc-sparkle';
    sparkle.style.left = x + 'px';
    sparkle.style.top = y + 'px';
    sparkle.style.setProperty('--x', (Math.random() * 120 - 60) + 'px');
    sparkle.style.setProperty('--y', (Math.random() * 120 - 60) + 'px');
    sparkle.style.setProperty('--rotate', (Math.random() * 360) + 'deg');
    document.body.appendChild(sparkle);

    let removed = false;
    const remove = () => {
      if (removed) return;
      removed = true;
      sparkle.remove();
    };
    sparkle.addEventListener('animationend', remove);
    setTimeout(remove, 800);
  }

  function burst(x, y) {
    const count = 8;
    for (let i = 0; i < count; i++) {
      setTimeout(() => createSparkle(x, y), i * 15);
    }
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest('.add-to-cart-button');
    if (!button) return;

    burst(e.clientX, e.clientY);
  }, true);
})(); 